const LogoIcon = () => {
  return (
    <div className="relative w-12 h-12 bg-gradient-to-br from-blue-500 to-purple-500 rounded-lg flex items-center justify-center shadow-lg">
      <img 
        src="/assets/logo-newsletter.png" 
        alt="NewsForYou Logo" 
        className="w-8 h-8 object-contain"
      />
    </div>
  );
};

export default LogoIcon;